import { useEffect, useState } from 'react';

import Loading from 'Components/Lib/Elements/Loading';
import loadJsonData from '../Utils/loadJsonData';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import deleteData from '../Utils/deleteData';
import ModalPopup from '../Common/ModalPopup';
import { AddViewProvider } from './AddView';
import Addbutton from '../Elements/Addbutton';
import { getPropertiesPerType } from 'Helpers/getPropertiesPerType';

/**
 * Renderes a List
 * @param {any} props Properties given by the caller
 * @returns {JSX.Element} Rendered Element.
 */
function CustomerNotesView(props: any): JSX.Element {
    const [loading, setLoading] = useState(true); // eslint-disable-line
    const [list, setList] = useState({ Data: [], Meta: {} });
    const [menuState, setMenuState] = useState({
        addMode: false,
    });
    const customerNumber = LocalStorage?.getTabData()?.primaryType === 'customer' ? LocalStorage?.getTabData().primaryId : 0;

    //TODO
    //load todays Appointments from Outlook
    //from - props.Listtype, today
    useEffect(() => {
        loadData();
    }, []);

    function deleteNote(noteId) {
        deleteData('/' + LocalStorage?.getConnectionKey() + URLS.DeleteNote + '?Index=' + noteId).then((data: any) => {
            if (data.Meta.Success) loadData();
            else console.log('Error' + data);
        });
    }
    function loadData() {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetNotes + '?FilterEntries=Data.Typ=1 AND Data.DocumentNumber=' + customerNumber).then(data => {
            if (data.Meta.Success && data.Data) {
                setList({ ...list, Data: data.Data as any, Meta: data.ListMeta });
                setLoading(false);
            }
        });
    }

    return (
        <>
            <div className="mfx-view mfx-listview">
                <div className="mfx-action-buttons">
                    <Addbutton
                        disableChangeHandler={(save: boolean) => {
                            setMenuState({ ...menuState, addMode: true });
                        }}
                        disableMode={menuState.addMode}
                    />
                </div>
                {loading && <Loading />}
                {!loading && (
                    <>
                        <ul className="mfx-list notes">
                            {list.Data.map((listitem: any, idx: any) => {
                                return (
                                    <li className="note-text" key={idx}>
                                        <span className='note-span'>{listitem.Text}</span>
                                        <button className="mfx-button" onClick={() => deleteNote(listitem.ID)}>
                                            <i className="icon-delete"></i>
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </>
                )}
                {!loading && list && list.Data.length <= 0 && <h4>{window.Dictionary.getTranslation(14470)}</h4>}
            </div>
            {menuState.addMode && (
                <ModalPopup modalClass="mfx-add-modal">
                    <AddViewProvider onSave={e => {setMenuState({ ...menuState, addMode: false }); loadData();}} withFilledData={true} viewData={{ Data: { Typ: 1, DocumentNumber: customerNumber } }} changeView={() => setMenuState({ ...menuState, addMode: false })} viewName={'NoteAddView'} viewSettings={getPropertiesPerType('CustomerNotesView')}>
                        <div className="mfx-action-buttons">
                            <Addbutton disableChangeHandler={() => setMenuState({ ...menuState, addMode: false })} disableMode={() => setMenuState({ ...menuState, addMode: false })} save={false} />
                        </div>
                    </AddViewProvider>
                </ModalPopup>
            )}
        </>
    );
}

export default CustomerNotesView;
